import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';

import { NotificationDialogComponent } from './components/notification-dialog/notification-dialog.component';
import { NotificationsConfigurationItemDialogComponent } from './components/notifications-configuration-item-dialog/notifications-configuration-item-dialog.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationRoutingModule, routedComponents } from './notification-routing.module';
import { NotificationDialogService } from './services/notification-dialog.service';
import { NotificationRestConnectorService } from './services/notification-rest-connector.service';
import { NotificationService } from './services/notification.service';
import { NotificationEffects } from './state/notification.effects';
import { notificationReducer } from './state/notification.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('notification', notificationReducer),
    EffectsModule.forFeature([
      NotificationEffects,
    ]),
    CommonModule,
    NotificationRoutingModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule,
    TranslateModule,
    EditorModule,
    SharedModule,
  ],
  providers: [
    NotificationService,
    NotificationRestConnectorService,
    NotificationEffects,
    NotificationDialogService,
  ],
  declarations: [
    routedComponents,
    NotificationsComponent,
    NotificationDialogComponent,
    NotificationsConfigurationItemDialogComponent,
  ],
  exports: [
    routedComponents,
    NotificationsComponent,
    NotificationsConfigurationItemDialogComponent,
  ],
  entryComponents: [
    NotificationDialogComponent,
    NotificationsConfigurationItemDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationModule { }
